// useAutoLogout.js
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { APPADMINCOOKIE, APPCOOKIE, APPPACKAGECOOKIE, SubDirectory } from './defaults';
import { useAuth } from 'components/custom/authprovider';

function useAutoLogout() {
  const {setWT, setIsAuthenticated}  = useAuth();
  let history = useHistory();

  const tokenString = localStorage.getItem(APPCOOKIE);
  if(tokenString){
    const userToken = JSON.parse(tokenString);

    useEffect(() => {
      const getTokenExpiration = () => {
        const expiration = userToken.dt;
        return expiration ? new Date(parseInt(expiration, 10)) : null; // Convert from Unix timestamp (seconds) to milliseconds
      };

      const logout = () => {
        localStorage.clear(APPCOOKIE);
        localStorage.clear(APPADMINCOOKIE);
        // sessionStorage.clear(APPPACKAGECOOKIE);
        setIsAuthenticated(false);
        setWT(null);
        // console.log("Logging Out")
        history.push("/" + SubDirectory + "login");
      };

      const expirationDate = getTokenExpiration();

      if (expirationDate) {
        const currentTime = new Date();
        const timeUntilExpiration = expirationDate - currentTime;

        // console.log("timeUntilExpiration", timeUntilExpiration);

        if (timeUntilExpiration <= 0) {
          logout();
        } else {
          const timer = setTimeout(() => {
            logout();
          }, timeUntilExpiration);

          return () => clearTimeout(timer);
        }
      }
    }, []);
  }
}

export default useAutoLogout;